var _rect, _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 32,
    fill: "#3D63DC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.07,
    cy: 34.0696,
    rx: 34.07,
    ry: 34.0696,
    transform: "matrix(0.642766 -0.766063 0.766026 0.64281 16 68.1995)",
    fill: "#ADCAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1008 85.9049C88.9611 87.2632 87.2646 88.0162 85.4915 88.0113C74.1267 87.9797 62.7079 84.1168 53.3212 76.24C44.2897 68.6611 38.5907 58.5842 36.3869 47.8676C35.9841 45.9093 36.45 43.8649 37.7225 42.3228C37.7828 42.2498 37.8434 42.177 37.9044 42.1043C49.9988 27.6898 71.4879 25.8097 85.9016 37.9049C100.315 50.0001 102.195 71.4904 90.1008 85.9049V85.9049Z",
    fill: "#C4D9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6042 58.3378C98.2279 62.0423 95.4387 65.3665 91.6824 65.3956C83.8675 65.456 75.9921 62.8423 69.5361 57.4248C63.0802 52.0073 59.1388 44.705 57.8412 36.998C57.2176 33.2935 60.0068 29.9692 63.7631 29.9402C71.578 29.8797 79.4534 32.4935 85.9093 37.911C92.3652 43.3284 96.3067 50.6307 97.6042 58.3378Z",
    fill: "#E5EEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvise);
export default __webpack_public_path__ + "static/media/envise.da0d7747edb3ab1f9fdd180045c4bacd.svg";
export { ForwardRef as ReactComponent };